import {useEffect,useRef,useState} from 'react';
import {api,useAuth} from '../context/AuthContext';

export default function useSavedRecords(){
 const {user}=useAuth(),uid=user?.user_id||'';
 const generation=useRef(0);
 const current=useRef(uid);current.current=uid;
 const [state,setState]=useState({owner:'',ids:[],loading:true,busy:false,error:''});
 useEffect(()=>{
  generation.current++;
  let alive=true;const controller=new AbortController();
  setState({owner:uid,ids:[],loading:!!uid,busy:false,error:''});
  if(uid)api.get('/saved-records',{signal:controller.signal}).then(r=>{
   if(!Array.isArray(r.data?.ids)||r.data.ids.some(id=>typeof id!=='string'))throw new Error('Invalid bookmarks');
   if(alive&&current.current===uid)setState({owner:uid,ids:r.data.ids,loading:false,busy:false,error:''});
  }).catch(()=>{if(alive&&current.current===uid)setState({owner:uid,ids:[],loading:false,busy:false,error:'load'});});
  return()=>{alive=false;controller.abort();};
 },[uid]);
 const visible=state.owner===uid?state:{ids:[],loading:!!uid,busy:false,error:''};
 async function toggle(value){
  if(!uid||visible.loading||visible.busy||visible.error)return;
  const id=String(value),selected=visible.ids.includes(id),owner=uid,epoch=generation.current;
  setState(s=>({...s,busy:true,error:''}));
  try{
   const r=await api[selected?'delete':'put']('/saved-records/'+encodeURIComponent(id));
   if(r.data?.item_id!==id||r.data.saved!==!selected)throw new Error('Invalid bookmark response');
   if(current.current===owner&&generation.current===epoch)setState(s=>({...s,ids:selected?s.ids.filter(x=>x!==id):[...s.ids,id],busy:false}));
  }catch{if(current.current===owner&&generation.current===epoch)setState(s=>({...s,busy:false,error:'save'}));}
 }
 return {...visible,toggle};
}
